/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Verify_Email_Page_TitleInputs */

const en_verify_email_page_title = /** @type {(inputs: Verify_Email_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verify your email address`)
};

const id_verify_email_page_title = /** @type {(inputs: Verify_Email_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifikasi alamat email Anda`)
};

const ms_verify_email_page_title = /** @type {(inputs: Verify_Email_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sahkan alamat emel anda`)
};

const ca_verify_email_page_title = /** @type {(inputs: Verify_Email_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifica la teva adreça de correu electrònic.`)
};

const cs_verify_email_page_title = /** @type {(inputs: Verify_Email_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ověřte svou emailovou adresu`)
};

const da_verify_email_page_title = /** @type {(inputs: Verify_Email_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekræft din e-mailadresse`)
};

const de_verify_email_page_title = /** @type {(inputs: Verify_Email_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestätigen Sie Ihre E-Mail-Adresse`)
};

const et_verify_email_page_title = /** @type {(inputs: Verify_Email_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kinnitage oma e-posti aadress`)
};

const es_verify_email_page_title = /** @type {(inputs: Verify_Email_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifica tu dirección de correo electrónico`)
};

const fr_verify_email_page_title = /** @type {(inputs: Verify_Email_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vérifiez votre adresse e-mail`)
};

const hr_verify_email_page_title = /** @type {(inputs: Verify_Email_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potvrdite svoju e-mail adresu.`)
};

const it_verify_email_page_title = /** @type {(inputs: Verify_Email_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifica il tuo indirizzo email`)
};

const lv_verify_email_page_title = /** @type {(inputs: Verify_Email_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apstipriniet savu e-pasta adresi.`)
};

const lt_verify_email_page_title = /** @type {(inputs: Verify_Email_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Patvirtinkite el. pašto adresą`)
};

const hu_verify_email_page_title = /** @type {(inputs: Verify_Email_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ellenőrizze az email címét`)
};

const nl_verify_email_page_title = /** @type {(inputs: Verify_Email_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifieer je e-mailadres`)
};

const nb_verify_email_page_title = /** @type {(inputs: Verify_Email_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekreft e-postadressen din`)
};

const pl_verify_email_page_title = /** @type {(inputs: Verify_Email_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zweryfikuj adres e-mail`)
};

const pt_verify_email_page_title = /** @type {(inputs: Verify_Email_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifique seu endereço de e-mail.`)
};

const ro_verify_email_page_title = /** @type {(inputs: Verify_Email_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificați adresa dvs. de e-mail`)
};

const sk_verify_email_page_title = /** @type {(inputs: Verify_Email_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overte svoju e-mailovú adresu`)
};

const sl_verify_email_page_title = /** @type {(inputs: Verify_Email_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preverite svoj e-poštni naslov`)
};

const fi_verify_email_page_title = /** @type {(inputs: Verify_Email_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vahvista sähköpostiosoitteesi.`)
};

const sv_verify_email_page_title = /** @type {(inputs: Verify_Email_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifiera din e-postadress`)
};

const vi_verify_email_page_title = /** @type {(inputs: Verify_Email_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xác minh địa chỉ email của bạn`)
};

const tr_verify_email_page_title = /** @type {(inputs: Verify_Email_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-posta adresinizi doğrulayın`)
};

const el_verify_email_page_title = /** @type {(inputs: Verify_Email_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Επαληθεύστε τη διεύθυνση email σας`)
};

const bg_verify_email_page_title = /** @type {(inputs: Verify_Email_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Потвърдете своя имейл адрес.`)
};

const ru_verify_email_page_title = /** @type {(inputs: Verify_Email_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подтвердите свой адрес электронной почты.`)
};

const sr_verify_email_page_title = /** @type {(inputs: Verify_Email_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Верификујте имејл адресу`)
};

const uk_verify_email_page_title = /** @type {(inputs: Verify_Email_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Підтвердьте вашу адресу електронної пошти`)
};

const ka_verify_email_page_title = /** @type {(inputs: Verify_Email_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`დაადასტურეთ თქვენი მეილის მისამართი.`)
};

const hi_verify_email_page_title = /** @type {(inputs: Verify_Email_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपना ईमेल पता सत्यापित करें`)
};

const th_verify_email_page_title = /** @type {(inputs: Verify_Email_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยืนยันที่อยู่อีเมลของคุณ`)
};

const ko_verify_email_page_title = /** @type {(inputs: Verify_Email_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이메일 주소 확인`)
};

const zh_verify_email_page_title = /** @type {(inputs: Verify_Email_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`验证您的电子邮件地址`)
};

const zh_tw_verify_email_page_title = /** @type {(inputs: Verify_Email_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`驗證您的電子郵件地址`)
};

const ja_verify_email_page_title = /** @type {(inputs: Verify_Email_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メールアドレスを確認する`)
};

/**
* | output |
* | --- |
* | "Verify your email address" |
*
* @param {Verify_Email_Page_TitleInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const verify_email_page_title = /** @type {((inputs?: Verify_Email_Page_TitleInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Verify_Email_Page_TitleInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_verify_email_page_title(inputs)
	if (locale === "ms") return ms_verify_email_page_title(inputs)
	if (locale === "ca") return ca_verify_email_page_title(inputs)
	if (locale === "cs") return cs_verify_email_page_title(inputs)
	if (locale === "da") return da_verify_email_page_title(inputs)
	if (locale === "de") return de_verify_email_page_title(inputs)
	if (locale === "et") return et_verify_email_page_title(inputs)
	if (locale === "es") return es_verify_email_page_title(inputs)
	if (locale === "fr") return fr_verify_email_page_title(inputs)
	if (locale === "hr") return hr_verify_email_page_title(inputs)
	if (locale === "it") return it_verify_email_page_title(inputs)
	if (locale === "lv") return lv_verify_email_page_title(inputs)
	if (locale === "lt") return lt_verify_email_page_title(inputs)
	if (locale === "hu") return hu_verify_email_page_title(inputs)
	if (locale === "nl") return nl_verify_email_page_title(inputs)
	if (locale === "nb") return nb_verify_email_page_title(inputs)
	if (locale === "pl") return pl_verify_email_page_title(inputs)
	if (locale === "pt") return pt_verify_email_page_title(inputs)
	if (locale === "ro") return ro_verify_email_page_title(inputs)
	if (locale === "sk") return sk_verify_email_page_title(inputs)
	if (locale === "sl") return sl_verify_email_page_title(inputs)
	if (locale === "fi") return fi_verify_email_page_title(inputs)
	if (locale === "sv") return sv_verify_email_page_title(inputs)
	if (locale === "vi") return vi_verify_email_page_title(inputs)
	if (locale === "tr") return tr_verify_email_page_title(inputs)
	if (locale === "el") return el_verify_email_page_title(inputs)
	if (locale === "bg") return bg_verify_email_page_title(inputs)
	if (locale === "ru") return ru_verify_email_page_title(inputs)
	if (locale === "sr") return sr_verify_email_page_title(inputs)
	if (locale === "uk") return uk_verify_email_page_title(inputs)
	if (locale === "ka") return ka_verify_email_page_title(inputs)
	if (locale === "hi") return hi_verify_email_page_title(inputs)
	if (locale === "th") return th_verify_email_page_title(inputs)
	if (locale === "ko") return ko_verify_email_page_title(inputs)
	if (locale === "zh") return zh_verify_email_page_title(inputs)
	if (locale === "zh-tw") return zh_tw_verify_email_page_title(inputs)
	if (locale === "ja") return ja_verify_email_page_title(inputs)
	return en_verify_email_page_title(inputs)
});